import * as Yup from 'yup'
import { validation as validationGeneral } from './GeneralDataForm/validation'

export const validationSchema = Yup.object().shape({
    ...validationGeneral,
})